import React from "react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast, { Toaster } from 'react-hot-toast';
import $ from 'jquery';
import Select from 'react-select'

import logo from '../../assets/sign/logo.png';
import fb from '../../assets/sign/fb.png';
import ln from '../../assets/sign/ln.png';
import tt from '../../assets/sign/tt.png';
import yt from '../../assets/sign/yt.png';
import pt from '../../assets/sign/pt.png';
import it from '../../assets/sign/it.png';
import bg from '../../assets/sign/bg.png';

import smart from '../../assets/sign/smart.png';
import ct from '../../assets/sign/ct.png';
import top from '../../assets/sign/top.png';
import think from '../../assets/sign/think.png';
import options from '../../assets/sign/options.json';



// react-bootstrap components
import {
    Badge,
    Button,
    Card,
    Navbar,
    Nav,
    Table,
    Container,
    Row,
    Col,
    Modal,
    Alert,
} from "react-bootstrap";

function Signature() {
    const [fullName, setFullName] = useState("Atiqullah Ahmadzai");
    const [title, setTitle]       = useState("Software Developer");
    const [email, setEmail]       = useState("atahmadzai@shipces.com");
    const [phone, setPhone]       = useState("+49 177 2838507");
    const [address, setAddress]   = useState("Continental Expedited Services, Inc.");
    const [division, setDivision]   = useState("Technology (Mexico)");

    const copyClipboard  = async ($class) => {
        var elm = $("."+$class)[0];
        // for Internet Explorer
  
        if(document.body.createTextRange) {
          var range = document.body.createTextRange();
          range.moveToElementText(elm);
          range.select();
          document.execCommand("Copy");
   
        }
        else if(window.getSelection) {
          // other browsers
  
          var selection = window.getSelection();
          var range = document.createRange();
          range.selectNodeContents(elm);
          selection.removeAllRanges();
          selection.addRange(range);
          document.execCommand("Copy");
          
        }
        toast.success("Signature coppied!");
      }

    return (
        <>
        <Toaster position="bottom-right" />
        <Row>
        
            <Col md="12">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Signature Parameters</h4>
                        <hr></hr>
                        
                        <div className="row">
                            <div className="col-md-6">
                                <label for="fullname">Full Name</label>
                                <input type="text" className="form-control" id="fullname" aria-describedby="fullname" placeholder="Enter full name" defaultValue={fullName} onChange={(e) => {setFullName(e.target.value)}}></input>
                            </div>
                            <div className="col-md-6">
                                <label for="phone">Title</label>
                                <Select options={options}  onChange={(e) => {setTitle(e.value)}} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label for="email">Email Address</label>
                                <input type="email" className="form-control" id="email" aria-describedby="email" placeholder="Enter email address" defaultValue={email}  onChange={(e) => {setEmail(e.target.value)}}></input>
                            </div>
                            <div className="col-md-6">
                                <label for="phone">Phone Number</label>
                                <input type="text" className="form-control" id="phone" aria-describedby="phone" placeholder="Enter phone number" defaultValue={phone}  onChange={(e) => {setPhone(e.target.value)}}></input>
                            </div>
                            {/* <div className="form-group col-md-3">
                                <label for="phone">Address</label>
                                <select  className="form-control" onChange={(e) => {setAddress(e.target.value)}}>
                                    <option value="CES Mexico División S.A. de C.V">CES Mexico División S.A. de C.V</option>
                                    <option value="Continental Expedited Services, Inc.">Continental Expedited Services, Inc.</option>
                                </select>
                            </div> */}

                            
                        </div>
                        <br></br>
                    </div>
                </div>
            </Col>
            
            <Col md="6">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Main Signature</h4>
                        <hr></hr>
                        <div className="result_1">
                            <table style={{ width: '540px', fontSize: '11pt', fontFamily: 'Open Sans, sans-serif' }} cellSpacing="0" cellPadding="0" border="0" width="540px">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '100px',verticalAlign:"top" }}>
                        
                                            <p style={{ margin: '0px', paddingBottom: '10px' }}>
                                                <img alt="Logo" style={{ width: '150px', height: 'auto', border: '0' }} src={logo} width="150" border="0" />
                                            </p>

                                            <p style={{ marginBottom: '10px', marginTop: '0', padding: '0', fontFamily: 'Open Sans, sans-serif', fontSize: '8pt', lineHeight: '2pt' }}>
                                                <a href="https://continentalexpedited.com/" style={{ color: '#1b1464', textDecoration: 'none', fontWeight: 'bold' }}>
                                                    <span style={{ textDecoration: 'none', fontSize: '8pt', lineHeight: '13pt', color: '#1b1464', fontFamily: 'Open Sans, sans-serif', fontWeight: 'bold' }}>www.shipces.com</span>
                                                </a>
                                            <br />
                                
                                                <span>
                                                    <a href="https://www.facebook.com/ContinentalExpedited/" target="_blank" rel="noopener">
                                                    <img src={fb} alt="facebook icon" style={{ border: '0', height: '16px', width: '16px' }} width="16" border="0" />
                                                    </a>
                                                    &nbsp;
                                                </span>
                                                <span>
                                                    <a href="https://de.linkedin.com/company/continental-expedited-services" target="_blank" rel="noopener">
                                                    <img src={ln} alt="linkedin icon" style={{ border: '0', height: '16px', width: '16px' }} width="16" border="0" />
                                                    </a>
                                                    &nbsp;
                                                </span>

                                            </p>
                                        </td>
                                    
                                        <td style={{ width: '10px', borderRight: '2px solid #1b1464' }}></td>

                                        <td style={{ width: '10px' }}></td>
                                        <td style={{ minWidth: '100px',verticalAlign:"top" }}>
                                            <span style={{ fontFamily: 'Open Sans, sans-serif', color: '#1b1464', fontWeight: 'bold', fontSize: '11pt', lineHeight: '13pt' }}>{fullName}</span>
                                            <br />
                                            <span style={{ fontFamily: 'Open Sans, sans-serif', color: '#333333', fontSize: '8pt', lineHeight: '12pt' }}>{title}</span>
                                            <p style={{ fontFamily: 'Open Sans, sans-serif', padding: '0', fontSize: '8pt', lineHeight: '14pt', marginBottom: '0' }}>
                                            <span style={{ fontFamily: 'Open Sans, sans-serif', fontSize: '8pt', lineHeight: '14pt' }}>
                                                <span style={{ fontSize: '8pt', lineHeight: '13pt', color: '#333333', fontWeight: 'bold' }}><strong>E:</strong></span>
                                                <a href={"mailto:"+email} style={{ fontSize: '8pt', color: '#333333', textDecoration: 'none' }}>
                                                <span style={{ textDecoration: 'none', fontSize: '8pt', lineHeight: '14pt', color: '#333333', fontFamily: 'Open Sans, sans-serif' }}> {email}</span>
                                                </a>
                                                <span><br /></span>
                                            </span>
                                            <span>
                                                <span style={{ fontSize: '8pt', color: '#333333', fontWeight: 'bold' }}><strong>M:</strong></span>
                                                <span style={{ fontSize: '8pt', color: '#333333' }}> <a href={"tel:"+phone} style={{color:"black"}}>{phone}</a></span>
                                                <span><br /></span>
                                            </span>
                                            <span>
                                                <span style={{ fontSize: '8pt', color: '#333333' }}> {address}</span>
                                                <span><br /></span>
                                                <span>{address.includes("Mexico") ? "Estados Unidos - México - Canadá" : "USA - Mexico - Canada"}</span>
                                            </span>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr><td><br></br></td></tr>
                                    <tr>
                                        <td colSpan={4}>
                                            <span>
                                                <img src={bg} alt="icons" style={{ border: '0', height: '38px', width: '380px' }} width="380" height='38' border="0" />
                                                &nbsp;
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>
                                            <p style={{color:"gray", fontFamily:"Open Sans, Helvetica, sans-serif", fontSize:"11px", fontStyle:"italic"}}>
                                                This email and any attachments are confidential and intended solely for the use of the individual or entity to whom they are addressed. If you have received this email in error, please notify the sender immediately and delete it from your system. Unauthorized disclosure, copying, or distribution of this email is prohibited.
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <hr></hr>
                        <button className="btn btn-primary" onClick={() => copyClipboard("result_1")}>Copy</button>
                    </div>
                </div>
            </Col>
            <Col md="6">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Plain Signature</h4>
                        <hr></hr>
                        <div className="result_2">
                            
                            <p style={{
                                fontFamily: 'Open Sans, Helvetica, sans-serif',
                                fontSize: 'small',
                                textAlign: 'start',
                                margin: '0in',
                                lineHeight: '12.65pt',
                                backgroundColor: 'white',
                                color: 'rgb(34, 34, 34)',
                                }}>
                                <strong>{fullName}</strong>
                                <br />
                                {title}
                                <br /><br />
                                <strong>Phone:</strong> {phone}
                                <br />
                                <strong>Mexico:</strong> (52) 442.477.07.02 
                                <br />
                                <strong>Toll Free:</strong> 855-SHIPCES
                                <br />
                                <strong>Fax:</strong> 877.744.3899
                                <br />
                                {address}
                                <br />
                                {address.includes("Mexico") ? "Estados Unidos - México - Canadá" : "USA - Mexico - Canada"}

                            </p>
                            
                        </div>
                        <hr></hr>
                        <button className="btn btn-primary" onClick={() => copyClipboard("result_2")}>Copy</button>
                    </div>
                </div>
            </Col>
        </Row>
        </>
        );
    }
    
    export default Signature;
    